import axios from "axios";
import {
  DAYS_OF_WEEK,
  MONTHS_OF_YEAR,
  MONTHS_OF_YEAR_FULL,
  DOB_DAYS,
  DOB_YEARS,
} from "./constants";
import { v4 as uuidv4 } from "uuid";

export {
  DAYS_OF_WEEK,
  MONTHS_OF_YEAR,
  MONTHS_OF_YEAR_FULL,
  DOB_DAYS,
  DOB_YEARS,
};

export const invertDateFormat = (date) => {
  if (date !== "") {
    let dArr = date.split("-");
    return dArr[2] + "-" + dArr[1] + "-" + dArr[0];
  }
  return date;
};

export const findObject = (ArrayOfObject, value) => {
  // eslint-disable-next-line array-callback-return
  let object = ArrayOfObject.find((item, index) => {
    if (item.my_route === value.replace(/\s/g, "")) {
      return ArrayOfObject[index];
    }
  });
  return object;
};

export const getUrlQuerysection = () => {
  let queries = window.location.search;
  return queries;
};

// this format numbers into kilo, Million, Billion ...
export const nFormatter = (num, digits) => {
  const lookup = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "k" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "B" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" },
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var item = lookup
    .slice()
    .reverse()
    .find(function (item) {
      return num >= item.value;
    });
  return item
    ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol
    : "0";
};

export const generateRandomNumber = () => {
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  return "_" + Math.random().toString(36).substr(2, 9);
};
export const getRandomIntInclusive = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min; // max & min both included
};

export const decodeToken = (token) => {
  if (!token) return {};

  var base64Url = token?.split(".")?.[1];
  var base64 = base64Url?.replace(/-/g, "+")?.replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      ?.split("")
      ?.map(function (c) {
        return "%" + ("00" + c?.charCodeAt(0)?.toString(16))?.slice(-2);
      })
      ?.join(""),
  );

  return JSON.parse(jsonPayload);
};

export const logoutHandler = () => {
  // handles logout
  localStorage.removeItem("platform");
  localStorage.removeItem("refreshToken");
  window.location.replace(`${window.location.origin}/login`);
};

// export const formatCurrency = (value, currencyCode, decimal = 2) => {
//   if (isNaN(value)) return "0.00";
//   return new Intl.NumberFormat("en-US", {
//     style: "currency",
//     currency: currencyCode,
//     minimumFractionDigits: decimal,
//     currencyDisplay: "symbol",
//   }).format(value);
// };

// Map of currency codes to manually force specific symbols
const CURRENCY_SYMBOL_MAP = {
  NGN: "₦",
  // Add others here if needed, e.g., XOF: "CFA", JPY: "¥"
};

export const formatCurrency = (
  currencyParams = {
    value: 0,
    decimal: 2,
    currencyCode: "NGN",
    useSymbol: true,
  },
) => {
  const { value, decimal, currencyCode } = currencyParams;

  // Ensure we have a valid 3-letter uppercase currency code
  const validCurrencyCode = /^[A-Z]{3}$/.test(currencyCode)
    ? currencyCode
    : "NGN";

  // Try to get symbol from Intl or fallback map
  let formatted = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: validCurrencyCode,
    minimumFractionDigits: decimal,
    currencyDisplay: "symbol",
  }).format(isNaN(value) ? 0 : value);

  // Manually override with known symbols
  const forcedSymbol = CURRENCY_SYMBOL_MAP[validCurrencyCode];
  if (forcedSymbol) {
    // Replace the default currency symbol part in the string
    const symbolRegex = /[^0-9.,\- ]+/; // Match non-numeric characters at start
    formatted = formatted?.replace(symbolRegex, forcedSymbol);
  }

  return formatted;
};

// Helper to format date as YYYY-MM-DD in UTC
export const formatDateUTC = (date) => {
  if (!date) return null;

  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(date.getUTCDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// Get today and N days ago
const getDateRange = (daysAgo) => {
  const endDate = new Date(); // Today (now)
  const startDate = new Date(endDate);
  startDate.setUTCDate(endDate.getUTCDate() - daysAgo);

  return [formatDateUTC(startDate), formatDateUTC(endDate)];
};

// Last 7 days (including today)
export const last7Days = () => {
  return getDateRange(6);
};

// Last 30 days (including today)
export const last30Days = () => getDateRange(29);

// Last 3 months ≈ 90 days
export const last3Months = () => getDateRange(89);

// Last year ≈ 364 days
export const lastYear = () => getDateRange(364);

export const getStartAndDate = (value) => {
  if (value === "last 7 days") {
    let date = last7Days();
    return {
      startDate: date[1],
      endDate: date[0],
    };
  }

  if (value === "last 30 days") {
    let date = last30Days();
    return {
      startDate: date[1],
      endDate: date[0],
    };
  }

  if (value === "last 3 months") {
    let date = last3Months();
    return {
      startDate: date[1],
      endDate: date[0],
    };
  }

  if (value === "1 year") {
    let date = lastYear();
    return {
      startDate: date[1],
      endDate: date[0],
    };
  }

  return {
    startDate: "",
    endDate: "",
  };
};

export const getDaysBetweenDate = (startDate, endDate) => {
  let date1 = new Date(startDate?.replace("-", "/"));
  let date2 = new Date(endDate?.replace("-", "/"));

  // To calculate the time difference of two dates
  let differenceInTime = date2.getTime() - date1.getTime();

  // To calculate the no. of days between two dates
  let differenceInDays = differenceInTime / (1000 * 3600 * 24);

  return differenceInDays;
};

export const getDateMargin = (startDate, endDate) => {
  let daysBetween = getDaysBetweenDate(startDate, endDate);

  if (daysBetween === 6) return "last 7 days";

  if (daysBetween > 6 && daysBetween <= 29) return "last 30 days";

  if (daysBetween > 29 && daysBetween <= 89) return "last 3 months";

  if (daysBetween > 89 && daysBetween <= 365) return "1 year";

  return "";
};

export const convertToTilteCase = (words) => {
  return words?.replace(/\w\S*/g, function (txt) {
    return txt?.charAt(0)?.toUpperCase() + txt?.substr(1)?.toLowerCase();
  });
};

export const mapUserRole = {
  BUSINESS_MANAGER: "Business Manager",
  ADMIN: "Admin",
  OWNER: "Owner",
  DEVELOPER: "Developer",
  CUSTOMER_SUPPORT: "Customer Support",
  CASHIER: "Cashier",
};

export const mask = (str, maskChar, unmaskedLength, maskFromStart = true) => {
  const maskStart = maskFromStart ? 0 : Math.max(0, unmaskedLength);
  const maskEnd = maskFromStart
    ? Math.max(0, str.length - unmaskedLength)
    : str.length;
  return str
    .split("")
    .map((char, index) => {
      if (index >= maskStart && index < maskEnd) {
        return maskChar;
      } else {
        return char;
      }
    })
    .join("");
};

export const formatDateToString = (date) => {
  const dateObj = new Date(date);
  let day = dateObj.getDay();
  const month = dateObj.getMonth();
  const year = dateObj.getFullYear();
  day = day - 1;
  day = day > DAYS_OF_WEEK.length ? day % DAYS_OF_WEEK : day;
  return `${DAYS_OF_WEEK[day]}, ${MONTHS_OF_YEAR[month]} ${year}`;
};

export const formatDateYYYYMMDD = (date) => {
  if (!date) return "";

  if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date.trim())) {
    return date.trim();
  }

  const d = new Date(date);
  if (isNaN(d.getTime())) return "";

  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const year = d.getFullYear();

  return [year, month, day].join("-");
};

export const formatDateDDMMYYYY = (date, divider = "-") => {
  if (!date) return "";

  const d = new Date(date);
  if (isNaN(d.getTime())) return "";

  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const year = d.getFullYear();

  return [day, month, year].join(divider);
};

export const setToDateMonthYearInWords = (value) => {
  const date = new Date(value);

  // Ensure valid date
  if (isNaN(date.getTime())) return "-";

  const day = date.getUTCDate();
  const month = date.getUTCMonth(); // Use UTC month
  const year = date.getUTCFullYear();

  const dayWithSuffix =
    day === 1 || day === 21 || day === 31
      ? `${day}st`
      : day === 2 || day === 22
        ? `${day}nd`
        : day === 3 || day === 23
          ? `${day}rd`
          : `${day}th`;

  return `${dayWithSuffix} ${MONTHS_OF_YEAR[month]}, ${year}`;
};

export const setToDateMonthYearInWordsByOnLocal = (value) => {
  const date = new Date(value);
  if (isNaN(date.getTime())) return "-";

  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();

  const dayWithSuffix =
    day === 1 || day === 21 || day === 31
      ? `${day}st`
      : day === 2 || day === 22
        ? `${day}nd`
        : day === 3 || day === 23
          ? `${day}rd`
          : `${day}th`;

  return `${dayWithSuffix} ${MONTHS_OF_YEAR[month]}, ${year}`;
};

export const truncateString = (str, length) => {
  str = `${str}`;
  if (str?.length > length) {
    return str?.substring(0, length) + "...";
  }
  return str;
};

export const subAccountColours = [
  { background: "#E8F7EE", color: "#19AE57" },
  { background: "#FFEEE9", color: "#FD561F" },
  { background: "#F2EDFE", color: "#7647EE" },
  { background: "#FEF7EB", color: "#F7AD3C" },
];

export const isMoreThan30DaysAgo = (date) => {
  //                   days  hours min  sec  ms
  const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;
  const timestampThirtyDaysAgo = new Date().getTime() - thirtyDaysInMs;

  if (timestampThirtyDaysAgo > date) {
    return true;
  } else {
    return false;
  }
};

export const serializeToPercent = (value) => {
  const _intValue = parseFloat(value);
  return _intValue * 100 + "%";
};

export const formatDate = (date, is_backwards = true, seperator = "-") => {
  if (!date) return "";

  const d = new Date(date);
  if (isNaN(d.getTime())) return "";

  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const year = d.getFullYear();

  if (is_backwards) return [year, month, day].join(seperator);
  return [day, month, year].join(seperator);
};

export const fixShortDate = (dateStr) => {
  if (!dateStr || typeof dateStr !== "string") return dateStr;

  // detects formats like 31-12-22 or 31-12-2022
  const match = dateStr.match(/^(\d{1,2})-(\d{1,2})-(\d{2}|\d{4})$/);
  if (!match) return dateStr;

  let [_, dd, mm, yy] = match;
  console.log(_);

  // convert 2-digit year to 4-digit (20xx assumption)
  if (yy.length === 2) yy = "20" + yy;

  return `${yy}-${mm}-${dd}`;
};

export const deepCopyFunction = (inObject) => {
  let outObject, value, key;

  if (typeof inObject !== "object" || inObject === null) {
    return inObject; // Return the value if inObject is not an object
  }

  // Create an array or object to hold the values
  outObject = Array.isArray(inObject) ? [] : {};

  for (key in inObject) {
    value = inObject[key];

    // Recursively (deep) copy for nested objects, including arrays
    outObject[key] = deepCopyFunction(value);
  }

  return outObject;
};

export function joinObj(arrayItems, attr) {
  var out = [];

  for (var i = 0; i < arrayItems?.length; i++) {
    out.push(arrayItems[i][attr]);
  }

  return out.join(", ");
}

export const getPlatform = () => {
  return window.location.pathname.includes("/mobile") ? "/mobile" : "/app";
};

export const isSellMode = () => {
  return window.location.pathname.includes("/sell-mode") ? true : false;
};

export const isViaWebView = () => {
  return localStorage.getItem("platform") === "webview" ? true : false;
};

export const reArrangeBusinessList = (
  business_list,
  currency_code,
  key = "id",
) => {
  let newList = [];
  business_list.forEach((item) => {
    let newObject = {
      tag: `${item.tag} --- Available Balance: ${formatCurrency({
        value: item.balance,
        currencyCode: currency_code,
      })}`,
      id: item?.[key],
      balance: item.balance,
    };
    newList.push(newObject);
  });
  return newList;
};

export const get422errorMessage = (errors) => {
  for (const key in errors) {
    if (typeof errors[key]?.[0] !== "string") {
      return get422errorMessage(errors?.[key]);
    } else
      return `${key?.replace("_", " ")?.toLocaleUpperCase()}: ${
        errors?.[key]?.[0]
      }`;
  }
};

export const getDateAfter = (period) => {
  const today = new Date();
  const newDate = new Date(
    new Date().setDate(today.getDate() + period),
  )?.toLocaleString("en-us");
  return setToDateMonthYearInWords(newDate);
};

export const calculateCartItem = ({
  cart_items: newCartItems,
  vat = 0,
  service_charge = 0,
  unique_cart_identifier = null,
  ...rest
}) => {
  let vatAmount = 0;
  const totalAmountItem = newCartItems?.reduce((accumulator, item) => {
    const itemTotal = Number(item.total_price) * Number(item?.unit?.value);

    // Only calculate VAT if it's not already included in the price
    if (!item.include_vat_in_price) {
      const vatPercent = Number(item?.vat || vat || 0);
      vatAmount = vatAmount + (vatPercent * itemTotal) / 100;
    }

    return Number(accumulator) + itemTotal;
  }, 0);

  const serviceChargeAmount = (Number(service_charge) * totalAmountItem) / 100;

  // create unique identifier
  let uniqueCartIdentifier = unique_cart_identifier;
  if (!uniqueCartIdentifier && newCartItems?.length > 0)
    uniqueCartIdentifier = uuidv4();

  return {
    data: newCartItems,
    unique_cart_identifier: uniqueCartIdentifier,
    ...rest,
    total_items: newCartItems?.length,
    total_amount:
      Number(totalAmountItem) + Number(vatAmount) + Number(serviceChargeAmount),
    total_items_amount: Number(totalAmountItem),
    vat_amount: Number(vatAmount),
    vat: Number(vat),
    service_charge: Number(service_charge),
    service_charge_amount: Number(serviceChargeAmount),
  };
};

export const getSellingPriceWithoutDiscount = ({
  inputed_selling_price,
  vat_percent = 0,
  discount_rate = 0,
  include_vat_in_price = false,
}) => {
  const discountAmount = Number((inputed_selling_price * discount_rate) / 100);
  const discountSellingAmount = Number(inputed_selling_price - discountAmount);
  const vatAmount = Number((discountSellingAmount * vat_percent) / 100);
  const unitPrice = discountSellingAmount + vatAmount;

  const sellingPriceWithoutDiscount = include_vat_in_price
    ? unitPrice + (unitPrice * discount_rate) / 100
    : discountSellingAmount + discountAmount;

  return Number(sellingPriceWithoutDiscount);
};

// this function removes null, undefined and empty string values from an object
export function cleanObject(obj, keys = [], exclude = []) {
  for (let propName in obj) {
    if (
      (obj[propName] === null ||
        obj[propName] === undefined ||
        obj[propName] === "" ||
        obj[propName] === "None") &&
      !exclude?.includes(propName)
    ) {
      delete obj[propName];
    }
  }
  // delete key name specified
  keys?.forEach((key) => {
    delete obj[key];
  });
  return obj;
}

export const getDefaultStoresId = (stores) => {
  let newArray = [];
  stores?.forEach((store) => {
    newArray.push(store?.id);
  });
  return newArray;
};

export const reLabelDefault = (stores) => {
  let newArray = [];
  stores?.forEach((store) => {
    newArray.push({ value: store?.id, label: store?.name });
  });
  return newArray;
};

export const reArrangeVariantStoreProperties = (variantStoreProperties) => {
  const newVariantStoreProperties = [];
  variantStoreProperties?.forEach((variantStoreProperty) => {
    const newStoreProperty = {
      ...variantStoreProperty,
      cost_price: `${variantStoreProperty?.cost_price || ""}`,
      selling_price: `${variantStoreProperty?.selling_price || ""}`,
      minimum_stock_quantity:
        variantStoreProperty?.minimum_stock_quantity === null ||
        variantStoreProperty?.minimum_stock_quantity === undefined
          ? undefined
          : `${variantStoreProperty?.minimum_stock_quantity}`,
      stock_quantity:
        variantStoreProperty?.stock_quantity === null ||
        variantStoreProperty?.stock_quantity === undefined
          ? undefined
          : `${variantStoreProperty?.stock_quantity}`,
      expiry_date: variantStoreProperty?.expiry_date || "",
      discount_rate: `${variantStoreProperty?.discount_rate || ""}`,
      supplier_id: `${variantStoreProperty?.supplier_id || ""}`,
    };
    newVariantStoreProperties.push(newStoreProperty);
  });
  return newVariantStoreProperties;
};

export const reArrangeVariant = (variants) => {
  const newVariants = [];

  variants?.forEach((variant) => {
    const newVariant = {
      ...variant,
      cost_price: `${variant?.cost_price || ""}`,
      selling_price: `${variant?.selling_price || ""}`,
      minimum_stock_quantity:
        variant?.minimum_stock_quantity === null ||
        variant?.minimum_stock_quantity === undefined
          ? undefined
          : `${variant?.minimum_stock_quantity}`,
      stock_quantity:
        variant?.stock_quantity === null ||
        variant?.stock_quantity === undefined
          ? undefined
          : `${variant?.stock_quantity}`,
      store_properties: reArrangeVariantStoreProperties(
        variant?.store_variant_properties,
      ),
    };
    delete newVariant.store_variant_properties;

    newVariants.push(newVariant);
  });
  return newVariants;
};

export const getVariantsProperties = (productDetails) => {
  return productDetails?.variants?.length > 0
    ? reArrangeVariant(productDetails?.variants)
    : [];
};

export const reArrangeStoreProperties = (storeProperties) => {
  const newStoreProperties = [];
  storeProperties?.forEach((storeProperty) => {
    const newStoreProperty = {
      ...storeProperty,
      cost_price: `${storeProperty?.cost_price || ""}`,
      selling_price: `${storeProperty?.selling_price || ""}`,
      minimum_stock_quantity:
        storeProperty?.minimum_stock_quantity === null ||
        storeProperty?.minimum_stock_quantity === undefined
          ? undefined
          : `${storeProperty?.minimum_stock_quantity}`,
      stock_quantity:
        storeProperty?.stock_quantity === null ||
        storeProperty?.stock_quantity === undefined
          ? undefined
          : `${storeProperty?.stock_quantity}`,
      expiry_date: storeProperty?.expiry_date || "",
      discount_rate: `${storeProperty?.discount_rate || ""}`,
      supplier_id: `${storeProperty?.supplier_id || ""}`,
      ledger_account_id: `${storeProperty?.ledger_account_id || ""}`,
    };

    newStoreProperties.push(newStoreProperty);
  });
  return newStoreProperties;
};

export const getDefaultPricingProperties = (pricingTypeId = 1) => {
  return {
    price: "",
    discount_rate: "",
    pricing_type_id: pricingTypeId,
    uuid: uuidv4(),
  };
};

export const getDefaultStoreProperties = (pricingTypeId) => {
  return {
    cost_price: "",
    stock_quantity: 0,
    restock_date: formatDateYYYYMMDD(Date.now()),
    expiry_date: "",
    minimum_stock_quantity: 0,
    store_id: null,
    store_name: null,
    barcode: "",
    item_level_tracking: false,
    apply_pricing_to_all_stores: false,
    items_number: [],
    pricings: [{ ...getDefaultPricingProperties(pricingTypeId) }],
  };
};

export const getDefaultVariantProperties = () => {
  return {
    option: "",
    value: "",
    barcode: "",
    image_url: "",
    uuid: uuidv4(),
    store_properties: [],
  };
};

// this function helps to update a store property on product creation without variants
export const updateStorePropertiesHelper = ({
  stores,
  useSamePricing,
  storeProperties,
  storeList,
}) => {
  const newStoreProperties = deepCopyFunction(storeProperties);
  // delete store properties that have been remove
  newStoreProperties?.forEach((item, index) => {
    if (!stores.find((storeItem) => storeItem?.value === item?.store_id))
      newStoreProperties.splice(index, 1);
    else if (useSamePricing) {
      newStoreProperties[index] = {
        ...newStoreProperties[0],
        store_id: newStoreProperties[index].store_id,
        store_name: newStoreProperties[index].store_name,
      };
    }
  });

  // add store properties for newly selected stores
  stores?.forEach((storeItem) => {
    if (
      !newStoreProperties.find((item) => item?.store_id === storeItem?.value)
    ) {
      const newProperties =
        useSamePricing && storeProperties?.length > 0
          ? { ...storeProperties?.[0] }
          : { ...getDefaultStoreProperties() };
      newProperties.store_id = storeItem?.value;
      newProperties.store_name = storeList?.find(
        (store) => store?.id === storeItem?.value,
      )?.name;
      newStoreProperties.push(newProperties);
    }
  });

  return newStoreProperties;
};

// this function adds new pricing option to store properties on product creation
export const addNewPricingForStorePropertyHelper = ({
  storeProperties,
  storeIndex,
}) => {
  const newStoreProperties = deepCopyFunction(storeProperties);
  newStoreProperties[storeIndex].pricings.push(getDefaultPricingProperties());
  return newStoreProperties;
};

// this function removes a pricing option from store properties on product creation
export const removePricingForStorePropertyHelper = ({
  storeProperties,
  storeIndex,
  pricingIndex,
}) => {
  const newStoreProperties = deepCopyFunction(storeProperties);
  newStoreProperties?.[storeIndex]?.pricings?.splice(pricingIndex, 1);
  return newStoreProperties;
};

// helps to create new variants store properties
export const createVariantPropertiesHelper = ({ storeList, stores }) => {
  const newVariant = getDefaultVariantProperties();
  const newStoreProperties = [];
  stores?.forEach((storeItem) => {
    const newProperties = {
      ...getDefaultStoreProperties(),
      store_id: storeItem?.value,
      useSameVariantPricing: false,
      store_name: storeList?.find((store) => store?.id === storeItem?.value)
        ?.name,
    };
    newStoreProperties.push(newProperties);
  });
  newVariant.store_properties = newStoreProperties;
  return newVariant;
};

// helps to update new variants store properties
export const updateVariantStorePropertiesHelper = ({
  storeList,
  stores,
  variantProperties,
}) => {
  // go through variant properties and update store properties
  const newVariantProperties = deepCopyFunction(variantProperties);
  // console.log(newVariantProperties);
  newVariantProperties?.forEach((variantItem, variantIndex) => {
    variantItem?.store_properties?.forEach(
      (storeProperty, storePropertyIndex) => {
        // delete store property for deleted stores
        if (
          !stores.find(
            (storeItem) => storeItem?.value === storeProperty?.store_id,
          )
        )
          variantItem?.store_properties?.splice(storePropertyIndex, 1);
        else if (variantItem?.useSameVariantPricing) {
          newVariantProperties[variantIndex].store_properties[
            storePropertyIndex
          ] = {
            ...deepCopyFunction(variantItem?.store_properties[0]),
            store_id: storeProperty.store_id,
            store_name: storeProperty.store_name,
          };
        }
      },
    );

    // add new store property for newly selected stores
    stores?.forEach((storeItem) => {
      if (
        !variantItem?.store_properties?.find(
          (item) => item?.store_id === storeItem?.value,
        )
      ) {
        const newProperties =
          variantItem?.useSameVariantPricing &&
          variantItem?.store_properties?.length > 0
            ? deepCopyFunction(variantItem?.store_properties?.[0])
            : { ...getDefaultStoreProperties() };
        newProperties.store_id = storeItem?.value;
        newProperties.store_name = storeList?.find(
          (store) => store?.id === storeItem?.value,
        )?.name;
        variantItem?.store_properties?.push(newProperties);
      }
    });
  });
  return newVariantProperties;
};

// helps to add new variants store properties
export const addNewVariantOptionHelper = ({ stores, storeList }) => {
  const newVariant = { ...getDefaultVariantProperties() };
  stores?.forEach((storeItem) => {
    const newProperties = {
      ...getDefaultStoreProperties(),
      useSameVariantPricing: false,
      store_id: storeItem?.value,
      store_name: storeList?.find((store) => store?.id === storeItem?.value)
        ?.name,
    };
    newVariant?.store_properties?.push(newProperties);
  });

  return newVariant;
};

// helps to remove variants store properties
export const removeVariantPropertyHelper = ({
  variantIndex,
  variantProperties,
}) => {
  const newVariantProperties = [...variantProperties];
  newVariantProperties.splice(variantIndex, 1);
  return newVariantProperties;
};

export const addNewPricingPropertyForVariantStorePropertyHelper = ({
  storeIndex,
  variantIndex,
  variantProperties,
}) => {
  const newVariantProperties = deepCopyFunction(variantProperties);
  newVariantProperties[variantIndex].store_properties[storeIndex].pricings.push(
    getDefaultPricingProperties(),
  );
  return newVariantProperties;
};

export const removePricingPropertyForVariantStorePropertyHelper = ({
  pricingIndex,
  storeIndex,
  variantIndex,
  variantProperties,
}) => {
  const newVariantProperties = deepCopyFunction(variantProperties);
  newVariantProperties[variantIndex].store_properties[
    storeIndex
  ].pricings.splice(pricingIndex, 1);
  return newVariantProperties;
};

export const findPricingViaIdHelper = (pricingTypeId, pricings = []) => {
  const pricingDetails = pricings?.find(
    (pricingItem) => `${pricingItem?.pricing_type?.id}` === `${pricingTypeId}`,
  );
  return pricingDetails;
};

export const getPriceWithoutDiscout = (product) => {
  return product.is_service
    ? product.store_service_properties[0]?.pricings?.find(
        (item) => item.pricing_type.id === product?.pricing_type?.id,
      )?.price
    : product.store_product_properties[0]?.pricings?.find(
        (item) => item.pricing_type.id === product?.pricing_type?.id,
      )?.price || 0;
};

export const getVariantPriceWithoutDiscout = (product) => {
  return (
    product.store_variant_properties[0]?.pricings?.find(
      (item) => item.pricing_type.id === product?.pricing_type?.id || 1,
    )?.price || 0
  );
};

export const getPriceWithDiscout = (product) => {
  const productKey = product.is_service
    ? "store_service_properties"
    : "store_product_properties";

  const pricingDetails = product?.[productKey][0]?.pricings?.find(
    (item) => item.pricing_type.id === product?.pricing_type?.id,
  );

  return pricingDetails?.unit_price;
};

export const getVariantPriceWithDiscout = (product) => {
  const unit_price = product?.store_variant_properties[0]?.pricings?.find(
    (item) => item.pricing_type.id === 1,
  )?.unit_price;

  return unit_price || 0;
};

export const handleStorefrontStatusIndicator = (value) => {
  if (value === "COMPLETED") {
    return <h4 style={{ color: "#19AE57" }}>Paid</h4>;
  } else if (value === "IN_PROGRESS") {
    return <h4 style={{ color: "#F7AD3C" }}>In Progress</h4>;
  } else if (value === "PLACED") {
    return <h4 style={{ color: "#F7AD3C" }}>Awaiting Payment</h4>;
  } else if (value === "PENDING") {
    return <h4 style={{ color: "#F7AD3C" }}>Pending</h4>;
  } else {
    return <h4 style={{ color: "#E02020" }}>Cancelled</h4>;
  }
};

export const handleRenderStatusIndicator = (value) => {
  if (value === "COMPLETED") {
    return { color: "#19AE57", backgroundColor: "#E5FFF0" };
  } else if (value === "IN_PROGRESS") {
    return { color: "#F7AD3C", backgroundColor: "#FEF7EB" };
  } else if (value === "PLACED") {
    return { color: "#F7AD3C", backgroundColor: "#FEF7EB" };
  } else if (value === "PENDING") {
    return { color: "#F7AD3C", backgroundColor: "#FEF7EB" };
  } else {
    return { color: "#E02020", backgroundColor: "#FFEEE9" };
  }
};

export const getDateInUTCFormat = ({ date = "", time = "" }) => {
  var d = new Date(date),
    month = "" + d.getMonth(),
    day = "" + d.getDate(),
    year = d.getFullYear();

  const timeSplit = time?.split(":");

  // Create a Date object
  const newDate = new Date(year, month, day, timeSplit?.[0], timeSplit?.[1]);

  // Convert to ISO 8601 format and manually append microseconds
  let isoString = newDate.toISOString();

  return isoString;
};

export const removeSpecialCharacter = (inputValue) => {
  const stringWithoutUnderscores = inputValue.replace(/_/g, " ");

  const properCaseString = stringWithoutUnderscores.replace(/\b\w/g, (char) =>
    char.toUpperCase(),
  );

  return properCaseString;
};

export const formatTimeFromTimestamp = (timestamp) => {
  const date = new Date(timestamp);

  let hours = date.getUTCHours();
  const minutes = date.getUTCMinutes().toString().padStart(2, "0");
  const seconds = date.getUTCSeconds().toString().padStart(2, "0");

  const period = hours >= 12 ? "PM" : "AM";

  hours = hours % 12 || 12;

  const formattedHours = hours.toString().padStart(2, "0");

  return `${formattedHours}:${minutes}:${seconds} ${period}`;
};

export const capitalizeLetter = (str) => {
  if (!str) return str; // Check if the string is empty
  return str?.charAt(0)?.toUpperCase() + str?.slice(1)?.toLowerCase();
};

export const extractDateOnly = (
  value,
  timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone,
) => {
  if (!value) return "-";

  const date = new Date(value);
  if (isNaN(date.getTime())) return "-";

  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);

  const year = parts.find((p) => p.type === "year").value;
  const month = parts.find((p) => p.type === "month").value;
  const day = parts.find((p) => p.type === "day").value;

  return `${year}-${month}-${day}`; // YYYY-MM-DD
};

export const extractReadableDateOnly = (
  value,
  timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone,
) => {
  if (!value) return "-";

  const date = new Date(value);
  if (isNaN(date.getTime())) return "-";

  return new Intl.DateTimeFormat("en-GB", {
    timeZone,
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(date);
};

const formatDayMonthDate = (value, { includeYear = true } = {}) => {
  if (!value || typeof value !== "string") return "N/A";

  const dateOnly = value.split("T")[0].trim().replace(/\//g, "-");
  const parts = dateOnly.split("-");

  let year = null;
  let month = null;
  let day = null;

  if (parts.length === 2) {
    // MM-DD format
    month = parseInt(parts[0], 10);
    day = parseInt(parts[1], 10);
  } else if (parts.length === 3) {
    const [p1, p2, p3] = parts;
    const n1 = parseInt(p1, 10);
    const n2 = parseInt(p2, 10);
    const n3 = parseInt(p3, 10);

    if (p1.length === 4 || n1 > 31) {
      // YYYY-MM-DD
      year = n1 === 0 ? null : n1;
      month = n2;
      day = n3;
    } else if (p3.length === 4 || n3 > 31) {
      // DD-MM-YYYY
      day = n1;
      month = n2;
      year = n3 === 0 ? null : n3;
    } else {
      year = n1 === 0 ? null : n1;
      month = n2;
      day = n3;
    }
  } else {
    return "N/A";
  }

  if (!month || !day || month < 1 || month > 12 || day < 1 || day > 31) {
    return "N/A";
  }

  const date = new Date(year || 2000, month - 1, day);
  if (Number.isNaN(date.getTime())) return "N/A";

  const shouldIncludeYear = includeYear && year !== null;
  return new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    month: "long",
    ...(shouldIncludeYear ? { year: "numeric" } : {}),
  }).format(date);
};

export const formatDateDayMonthYear = (value) =>
  formatDayMonthDate(value, { includeYear: true });

export const formatDateDayMonth = (value, options = {}) =>
  formatDayMonthDate(value, {
    ...options,
    includeYear: options.includeYear ?? true,
  });

export function parseDob(dateStr) {
  if (!dateStr || typeof dateStr !== "string") {
    return { dob_day: "", dob_month: "", dob_year: "" };
  }
  const cleanDate = dateStr.split("T")[0].trim().replace(/\//g, "-");
  const parts = cleanDate.split("-");

  if (parts.length === 2) {
    // MM-DD format
    const [month, day] = parts;
    return {
      dob_day: parseInt(day, 10) || "",
      dob_month: parseInt(month, 10) || "",
      dob_year: "",
    };
  }

  if (parts.length === 3) {
    const [p1, p2, p3] = parts;
    const n1 = parseInt(p1, 10);
    const n2 = parseInt(p2, 10);
    const n3 = parseInt(p3, 10);

    if (p1.length === 4 || n1 > 31) {
      // YYYY-MM-DD
      return {
        dob_day: n3 || "",
        dob_month: n2 || "",
        dob_year: n1 === 0 ? "" : n1 || "",
      };
    } else if (p3.length === 4 || n3 > 31) {
      // DD-MM-YYYY
      return {
        dob_day: n1 || "",
        dob_month: n2 || "",
        dob_year: n3 === 0 ? "" : n3 || "",
      };
    } else {
      return {
        dob_day: n3 || "",
        dob_month: n2 || "",
        dob_year: n1 === 0 ? "" : n1 || "",
      };
    }
  }

  return { dob_day: "", dob_month: "", dob_year: "" };
}

export function buildDob(data) {
  const { dob_day, dob_month, dob_year, ...rest } = data;
  if (dob_day && dob_month) {
    const month = String(dob_month).padStart(2, "0");
    const day = String(dob_day).padStart(2, "0");
    const parsedYear = parseInt(dob_year, 10);
    if (parsedYear && parsedYear > 0) {
      const year = String(parsedYear).padStart(4, "0");
      return { ...rest, date_of_birth: `${year}-${month}-${day}` };
    }
    return { ...rest, date_of_birth: `${month}-${day}` };
  }
  return rest;
}

export const defaultDateDisplay = (
  value,
  timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone,
) => {
  if (!value) return "-";

  const date = new Date(value);
  if (isNaN(date.getTime())) return "-";

  return new Intl.DateTimeFormat("en-GB", {
    timeZone,
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).format(date);
};

export const defaultDateOnlyDisplay = (
  value,
  timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone,
) => {
  if (!value) return "-";

  const date = new Date(value);
  if (isNaN(date.getTime())) return "-";

  return new Intl.DateTimeFormat("en-US", {
    timeZone,
    year: "numeric",
    month: "short",
    day: "2-digit",
  }).format(date);
};

export const formatNumberWithCommas = (number = 0) => {
  if (!number) return 0;
  number = `${number}`;
  const [integerPart, decimalPart] = number?.split(".");

  // Add commas to the integer part
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Return the formatted number with decimals (if any)
  return decimalPart || number?.includes(".")
    ? `${formattedInteger}.${decimalPart || ""}`
    : formattedInteger;
};

export const removeCommas = (numberWithCommas = 0) => {
  if (!numberWithCommas && numberWithCommas !== 0) return numberWithCommas;
  return `${numberWithCommas}`?.replace(/,/g, "");
};

export const encodeToBase64 = (input) => {
  return btoa(unescape(encodeURIComponent(input)));
};

export const getLocalNetworkIP = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_LUMI_PRINT_DRIVER_BASE_URL}/print/local-ip`,
    );
    const data = await response?.json();
    const ip = data.ip;

    return ip;
  } catch (error) {
    return null;
  }
};

export const createHttpClient = async () => {
  let baseUrlBusiness = process.env.REACT_APP_LUMI_MERCHANT_APP_BASE_URL;
  const backendLocalPort = process.env.REACT_APP_LUMI_MERCHANT_APP_BACKEND_PORT;

  let baseURL;

  if (process.env.REACT_APP_ENV === "localSetup") {
    const originUrl = window.location.origin;
    const urlObject = new URL(originUrl);
    const hostname = urlObject.hostname;

    baseURL = `http://${hostname}:${backendLocalPort}/api`;
  } else {
    baseURL = baseUrlBusiness;
  }
  return axios.create({ baseURL: baseURL });
};

export const getValidationErrorMessage = (errors) => {
  for (const key in errors) return errors?.[key]?.message;
};

export const reArrangeCartItems = (items, storeId) => {
  return items?.map((item) => {
    const isService = item?.service ? true : false;
    const productType = isService
      ? "store_service_properties"
      : "store_product_properties";
    const isCustomPrice = item?.is_custom_price;
    const customPrice = isCustomPrice ? item?.unit_price : undefined;
    // const variant = item?.variant
    //   ? {
    //       ...item?.variant,
    //       store_variant_properties: [
    //         item?.variant?.store_variant_properties?.find(
    //           (variantItem) => `${variantItem?.store_id}` === `${storeId}`,
    //         ),
    //       ],
    //     }
    //   : null;
    const unitPrice = item?.unit_price;

    const unitOptions = [
      ...(item?.product?.additional_units || []),
      { unit: { ...item?.base_unit }, value: 1 },
    ];

    const unitValue =
      unitOptions?.find(
        (unitItem) => `${unitItem?.unit?.id}` === `${item?.selling_unit?.id}`,
      )?.value || 1;

    const unitTotalPrice =
      Number(item?.total_price || 0) / Number(unitValue || 1);

    return {
      ...item,
      id: `${item?.product?.id || item?.service?.id}${item?.variant?.id || ""}`,
      is_service: isService,
      unit_price: unitPrice,
      custom_price: customPrice,
      pricing_type_id: item?.pricing_type?.id,
      quantity: item?.base_quantity / Number(unitValue || 1),
      unit: {
        id: item?.selling_unit?.id || null,
        value: unitValue,
        unit: item?.selling_unit?.unit || null,
      },
      total_price: unitTotalPrice,
      inputed_selling_price: item?.selling_price,
      item_numbers: item?.inventory_items?.map((item) => item?.item_number),
      vat: isService ? item?.service?.vat : item?.product?.vat,
      include_vat_in_price: isService
        ? item?.service?.include_vat_in_price
        : item?.product?.include_vat_in_price,
      product: isService
        ? {
            ...item?.service,
            [productType]: [
              {
                pricings: item?.pricings,
                store_id: storeId,
              },
            ],
            is_service: isService,
          }
        : {
            ...item?.product,
            variant: item?.variant
              ? {
                  ...item?.variant,
                  store_variant_properties: [
                    item?.variant?.store_variant_properties?.find(
                      (variantItem) =>
                        `${variantItem?.store_id}` === `${storeId}`,
                    ),
                  ],
                }
              : null,
            [productType]: [
              {
                pricings: item?.pricings,
                store_id: storeId,
              },
            ],
            is_service: isService,
          },
    };
  });
};

export const getRefreshToken = () => {
  return localStorage.getItem("refreshToken");
};

export const isCashierUser = () => {
  const token = decodeToken(getRefreshToken());
  const isCashierLogin = token?.is_access_code_login === true;

  return isCashierLogin;
};

export const cropCanvas = (canvas) => {
  const ctx = canvas.getContext("2d");
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;

  let top = 0;
  let bottom = canvas.height - 1;

  // Find top boundary
  outerLoopTop: for (let y = 0; y < canvas.height; y++) {
    for (let x = 0; x < canvas.width; x++) {
      if (data[(y * canvas.width + x) * 4 + 3] > 0) {
        top = y;
        break outerLoopTop;
      }
    }
  }

  // Find bottom boundary
  outerLoopBottom: for (let y = canvas.height - 1; y >= 0; y--) {
    for (let x = 0; x < canvas.width; x++) {
      if (data[(y * canvas.width + x) * 4 + 3] > 0) {
        bottom = y;
        break outerLoopBottom;
      }
    }
  }

  const croppedHeight = bottom - top + 1;

  const croppedCanvas = document.createElement("canvas");
  croppedCanvas.width = canvas.width;
  croppedCanvas.height = croppedHeight;
  const croppedCtx = croppedCanvas.getContext("2d");

  croppedCtx.drawImage(
    canvas,
    0,
    top,
    canvas.width,
    croppedHeight,
    0,
    0,
    canvas.width,
    croppedHeight,
  );

  return croppedCanvas;
};

export const toQueryString = (params) => {
  return Object.entries(params)
    .filter(
      ([_, value]) =>
        value !== null &&
        value !== "" &&
        !(Array.isArray(value) && value.length === 0),
    )
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        return `${key}=${value.join("|")}`;
      } else {
        return `${key}=${value}`;
      }
    })
    .join("&");
};

const pad = (n) => n.toString().padStart(2, "0");

const parseHMS = (timeStr = "00:00:00") => {
  const [h = 0, m = 0, s = 0] = timeStr
    .split(":")
    .map((p) => parseInt(p, 10) || 0);
  return { hours: h, minutes: m, seconds: s };
};

export const getHourIntervals = (start, end, intervalMinutes = 30) => {
  const result = [];

  const formatLabel = (hours, minutes) => {
    const period = hours >= 12 ? "PM" : "AM";
    const hour12 = hours % 12 || 12;
    const min = pad(minutes);
    return `${hour12}:${min} ${period}`;
  };

  if (
    (start === "00:00:00" || start === "00:00") &&
    (end === "00:00:00" || end === "00:00")
  ) {
    for (let h = 0; h < 24; h++) {
      for (let m = 0; m < 60; m += intervalMinutes) {
        result.push({
          label: formatLabel(h, m),
          value: `${pad(h)}:${pad(m)}:00`,
        });
      }
    }
    return result;
  }

  const { hours: sh, minutes: sm, seconds: ss } = parseHMS(start);
  const { hours: eh, minutes: em, seconds: es } = parseHMS(end);

  let current = new Date(1970, 0, 1, sh, sm, ss);
  const endTime = new Date(1970, 0, 1, eh, em, es);

  if (endTime < current) return [];

  while (current <= endTime) {
    const h = current.getHours();
    const m = current.getMinutes();
    const label = formatLabel(h, m);
    const value = `${pad(h)}:${pad(m)}:${pad(current.getSeconds())}`;
    result.push({ label, value });
    current = new Date(current.getTime() + intervalMinutes * 60 * 1000);
  }

  const lastValue = result[result.length - 1]?.value;
  const endValue = `${pad(eh)}:${pad(em)}:${pad(es)}`;
  if (lastValue !== endValue) {
    result.push({ label: formatLabel(eh, em), value: endValue });
  }

  return result;
};

export function buildISODateTime(scheduleDate, scheduleTime) {
  if (!scheduleDate || !scheduleTime) return null;

  const [h = "0", m = "0", s = "0"] = scheduleTime.split(":");
  const hours = parseInt(h, 10);
  const minutes = parseInt(m, 10);
  const seconds = parseInt(s, 10);

  const date = new Date(scheduleDate);
  if (isNaN(date)) return null;

  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const hh = String(hours).padStart(2, "0");
  const min = String(minutes).padStart(2, "0");
  const ss = String(seconds).padStart(2, "0");

  return `${yyyy}-${mm}-${dd}T${hh}:${min}:${ss}`;
}

export const capitalizeFirstLetterOfEachWords = (str) => {
  // 1. Split the string into an array of words
  const words = str?.split(" ");

  // 2. Map over the array, capitalizing the first letter of each word
  const capitalizedWords = words?.map((word) => {
    if (word?.length === 0) {
      return ""; // Handle empty words (e.g., multiple spaces)
    }
    return word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase();
  });

  // 3. Join the capitalized words back into a single string
  return capitalizedWords?.join(" ");
};

// Derive WebSocket base URL from the API URL
export const getWebSocketBase = () => {
  let baseUrlBusiness = process.env.REACT_APP_LUMI_MERCHANT_APP_BASE_URL;

  // Replace https -> wss and remove /api if present
  const wsBase = baseUrlBusiness
    .replace(/^https/, "wss")
    .replace(/\/api\/?$/, ""); // remove trailing /api

  return wsBase;
};

// Build full WebSocket URL for a given endpoint
export const getWebSocketUrl = (token) => {
  const base = getWebSocketBase();
  return `${base}/ws/?token=${token}`;
};

export const objectToArrays = (obj) => {
  const keys = Object.keys(obj);
  const values = Object.values(obj);
  return { keys, values };
};

export const convertToNumber = (value) => {
  try {
    const num = Number(value);
    if (isNaN(num)) throw new Error("Not a number");

    // Only format if there *is* a decimal part
    if (num % 1 !== 0) {
      return num.toFixed(2);
    }

    return num; // return as-is if no decimals
  } catch (err) {
    return value; // fallback to original value
  }
};

export const combineActivityLogs = (logs) => {
  const map = {};

  logs.forEach((entry) => {
    const key = `${entry.object_id}-${entry.model_name}-${entry.action}`;

    if (!map[key]) {
      map[key] = {
        id: entry.id,
        model_name: entry.model_name,
        object_id: entry.object_id,
        object_label: entry.object_label,
        action: entry.action,
        event_time: entry.event_time,
        updated_fields: { ...entry.updated_fields },
      };
    } else {
      // merge updated fields
      map[key].updated_fields = {
        ...map[key].updated_fields,
        ...entry.updated_fields,
      };

      // update event time to the latest
      if (new Date(entry.event_time) > new Date(map[key].event_time)) {
        map[key].event_time = entry.event_time;
        map[key].id = entry.id;
      }
    }
  });

  // convert map back to array
  return Object.values(map);
};

export const getDaysUntilNextSubscription = (next_subscription_date) => {
  if (!next_subscription_date) return 0;

  const now = new Date();
  const targetDate = new Date(next_subscription_date);

  if (isNaN(targetDate)) return 0;

  const diffInMs = targetDate.getTime() - now.getTime();
  const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));

  return diffInDays > 0 ? diffInDays : 0;
};

export const monthYearInWords = (value) => {
  const date = new Date(value);

  // Ensure valid date
  if (isNaN(date.getTime())) return "-";

  const month = date.getUTCMonth(); // Use UTC month
  const year = date.getUTCFullYear();

  return `${MONTHS_OF_YEAR[month]}, ${year}`;
};

export const toAmPm = (time) => {
  const [hours, minutes] = time.split(":").map(Number);

  const period = hours >= 12 ? "pm" : "am";
  const hour12 = hours % 12 || 12;

  return `${hour12}:${minutes.toString().padStart(2, "0")}${period}`;
};

export const getDurationTime = (time, duration) => {
  let [hours, minutes] = time.split(":").map(Number);

  const totalMinutes = hours * 60 + minutes + duration;

  const newHours = Math.floor((totalMinutes / 60) % 24);
  const newMinutes = totalMinutes % 60;

  return `${newHours.toString().padStart(2, "0")}:${newMinutes
    .toString()
    .padStart(2, "0")}`;
};

export const accountTypes = [
  { label: "Assets", value: "assets" },
  { label: "Liabilities", value: "liabilities" },
  { label: "Equity", value: "equity" },
  { label: "Revenue", value: "revenue" },
  { label: "Expenses", value: "expenses" },
];

export const bankAccountTypes = [
  { label: "Savings", value: "savings" },
  { label: "Current", value: "current" },
  { label: "Fixed", value: "fixed" },
];

export const reArrangeProductsForTable = (
  productList = [],
  store_id,
  productTypeName = "store_product_properties",
) => {
  const results = productList?.map((product) => {
    const store_currency = product?.stores?.find(
      (store) => `${store?.id}` === `${store_id}`,
    )?.currency_code;

    const subResult = {
      ...product,
      cost_price:
        product?.[productTypeName]?.length > 0
          ? product?.[productTypeName]?.[0]?.cost_price
          : null,
      pricings:
        product?.[productTypeName]?.length > 0
          ? product?.[productTypeName]?.[0]?.pricings
          : null,
      stock_quantity:
        product?.[productTypeName]?.length > 0
          ? product?.[productTypeName]?.[0]?.stock_quantity
          : null,
      minimum_stock_quantity:
        product?.[productTypeName]?.length > 0
          ? product?.[productTypeName]?.[0]?.minimum_stock_quantity
          : null,
      store_currency: store_currency,

      subRows:
        product?.variants?.length > 0
          ? product?.variants?.map((variant, index) => ({
              id: product?.id,
              option: variant?.option,
              value: variant?.value,
              name: product?.name,
              cost_price: variant?.store_variant_properties?.[0]?.cost_price,
              pricings: variant?.store_variant_properties?.[0]?.pricings,
              variant_id: product?.variants[index]?.id,
              stock_quantity:
                variant?.store_variant_properties?.[0]?.stock_quantity,
              store_currency: store_currency,
            }))
          : null,
    };
    return subResult;
  });

  return results;
};

export const rearrangeChowdeckProductList = (productList = []) => {
  const selectedData = {};
  const selectedIds = {};
  productList?.forEach((product) => {
    const lumi_product = product?.mapped_to;
    if (lumi_product) {
      const productKey =
        lumi_product?.lumi_object_type === "product"
          ? "product_id"
          : lumi_product?.lumi_object_type === "variant"
            ? "variant_id"
            : lumi_product?.lumi_object_type === "service"
              ? "service_id"
              : "none";

      const objectId =
        lumi_product?.lumi_object_id ||
        lumi_product?.product_id ||
        lumi_product?.variant_id ||
        lumi_product?.service_id;

      selectedData[product?.marketplace_product_ref] = {
        [productKey]: objectId,
        lumi_object_id: objectId,
        lumi_product_name:
          lumi_product?.lumi_product_name ||
          lumi_product?.name ||
          lumi_product?.product_name,
        markup_override: lumi_product?.markup_override,
        marketplace_product_name: product?.marketplace_product_name,
      };

      selectedIds[product?.marketplace_product_ref] = true;
    }
  });

  return {
    selectedData,
    selectedIds,
  };
};

export const calculateTaxInclusiveAmount = ({ taxRate, principalAmount }) => {
  taxRate = Number(taxRate);
  principalAmount = Number(principalAmount);
  return (principalAmount - principalAmount / (1 + taxRate / 100)).toFixed(2);
};

export const calculateTaxAmount = ({ taxRate, principalAmount }) => {
  taxRate = Number(taxRate);
  principalAmount = Number(principalAmount);
  return ((taxRate * principalAmount) / 100).toFixed(2);
};

export const jounralStatusMap = {
  POSTED: "success--squared",
  DRAFT: "pending--squared",
  IN_REVIEW: "purple--squared",
  CANCELED: "failed--text",
  VOIDED: "failed--text",
};

export const monthStartAndEndDate = (
  timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone,
) => {
  const now = new Date();

  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    year: "numeric",
    month: "2-digit",
  }).formatToParts(now);

  const year = parseInt(parts.find((p) => p.type === "year").value);
  const month = parseInt(parts.find((p) => p.type === "month").value);

  // new Date(year, month, 0) uses JS 0-indexed months, so passing the
  // 1-indexed month gives the last day of the current month
  const lastDay = new Date(year, month, 0).getDate();

  const pad = (n) => String(n).padStart(2, "0");

  return {
    startOfMonth: `${year}-${pad(month)}-01`,
    endOfMonth: `${year}-${pad(month)}-${pad(lastDay)}`,
  };
};
export const menuProductRestructure = (productList = []) => {
  const newProductList = [];
  productList?.forEach((productItem) => {
    if (productItem?.variants?.length > 0) {
      productItem?.variants?.forEach((productVariantItem) => {
        newProductList?.push({
          name: `${productItem?.name} -- (${productVariantItem?.option}: ${productVariantItem?.value})`,
          product_id: productItem?.id,
          variant_id: productVariantItem?.id,
          category_name: productItem?.categories
            ?.map((item) => item?.name)
            ?.join(", "),
          pricings: productVariantItem?.store_variant_properties?.[0]?.pricings,
          selling_price:
            productVariantItem?.store_variant_properties?.[0]?.pricings[0]
              ?.price,
          unit_price:
            productVariantItem?.store_variant_properties?.[0]?.pricings[0]
              ?.unit_price,
          stock_quantity:
            productVariantItem?.store_variant_properties?.[0]?.stock_quantity,
          minimum_stock_quantity:
            productVariantItem?.store_variant_properties?.[0]
              ?.minimum_stock_quantity,
          is_service: productItem?.is_service,
          isSelected: false,
        });
      });
    } else {
      const productType = productItem?.is_service
        ? "store_service_properties"
        : "store_product_properties";
      newProductList?.push({
        name: productItem?.name,
        [productItem?.is_service ? "service_id" : "product_id"]:
          productItem?.id,
        category_name: productItem?.categories
          ?.map((item) => item?.name)
          ?.join(", "),
        pricings: productItem?.[productType]?.[0]?.pricings,
        selling_price: productItem?.[productType]?.[0]?.pricings[0]?.price,
        unit_price: productItem?.[productType]?.[0]?.pricings[0]?.unit_price,
        stock_quantity: productItem?.[productType]?.[0]?.stock_quantity,
        minimum_stock_quantity:
          productItem?.[productType]?.[0]?.minimum_stock_quantity,
        is_service: productItem?.is_service,
        isSelected: false,
      });
    }
  });

  return newProductList;
};

export const accountingSources = [
  {
    name: "All Sources",
    id: null,
  },
  {
    name: "Sales",
    id: "sale",
  },
  {
    name: "Expenses",
    id: "expense",
  },
  {
    name: "Restock",
    id: "restock",
  },
  {
    name: "User Entry",
    id: "user_entry",
  },
  {
    name: "Deposit",
    id: "deposit",
  },
  {
    name: "Transfer",
    id: "transfer",
  },
  {
    name: "Withdrawal",
    id: "withdrawal",
  },
  {
    name: "Store Wallet",
    id: "store_wallet",
  },
  {
    name: "Bill",
    id: "bill",
  },
  {
    name: "Returns",
    id: "returns",
  },
  {
    name: "Procurement",
    id: "procurement",
  },
  {
    name: "Invoice",
    id: "invoice",
  },
  {
    name: "Invoice Payment",
    id: "invoice_payment",
  },
  {
    name: "Customer Credit",
    id: "customer_credit",
  },
  {
    name: "Other",
    id: "other",
  },
];

export const dayOptions = Array.from({ length: 31 }, (_, index) => ({
  id: `${index + 1}`,
  name: `${index + 1}`,
}));

export const monthOptions = Array.from({ length: 12 }, (_, index) => {
  const value = index + 1;
  return {
    id: `${value}`,
    name: new Date(2024, value - 1, 1).toLocaleString("en-US", {
      month: "short",
    }),
  };
});

export const convertHtmlToPlainText = (html) => {
  if (!html) return "";
  let text = html
    .replace(/<br\s*[/]?>/gi, "\n")
    .replace(/<\/p>\s*<p>/gi, "\n\n")
    .replace(/<p>/gi, "")
    .replace(/<\/p>/gi, "\n");
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = text;
  return (tempDiv.textContent || tempDiv.innerText || "").trim();
};

export const toMonthKey = (year, month) => year * 12 + month;

export const parseDateString = (dateStr) => {
  if (!dateStr) return null;
  const parts = dateStr.split("-");
  if (parts.length < 2) return null;
  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1;
  if (isNaN(year) || isNaN(month)) return null;
  return { year, month };
};

export const formatDateToISO = (year, month, isEndOfMonth = false) => {
  const monthStr = String(month + 1).padStart(2, "0");
  if (!isEndOfMonth) {
    return `${year}-${monthStr}-01`;
  }
  const lastDay = new Date(year, month + 1, 0).getDate();
  return `${year}-${monthStr}-${String(lastDay).padStart(2, "0")}`;
};

export const formatMessageTime = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
};

// resolves a list of stores (ids or store objects) to comma separated names
export const getStoreNames = (stores = [], storeList = []) => {
  return (stores || [])
    .map((store) => {
      if (typeof store === "object") return store?.name;
      return storeList?.find((item) => `${item?.id}` === `${store}`)?.name;
    })
    .filter(Boolean)
    .join(", ");
};

export const formatDiscountInItemName = (name) => {
  if (!name || typeof name !== "string") return name;
  return name.replace(/\((\d+(?:\.\d+)?)\s*%\s*OFF\)/gi, (match, p1) => {
    return `(${Number(p1).toFixed(2)}% OFF)`;
  });
};

export const calculateOrderTotalItemDiscount = (orderDetails) => {
  if (!orderDetails) return 0;

  if (
    orderDetails?.item_discount_amount &&
    Number(orderDetails.item_discount_amount) > 0
  ) {
    return Number(orderDetails.item_discount_amount);
  }

  const items = orderDetails?.order_items;
  if (!Array.isArray(items) || items.length === 0) return 0;

  const total = items.reduce((acc, item) => {
    if (
      item?.total_discount_amount !== undefined &&
      item?.total_discount_amount !== null &&
      Number(item.total_discount_amount) > 0
    ) {
      return acc + Number(item.total_discount_amount);
    }

    if (
      item?.discount_amount !== undefined &&
      item?.discount_amount !== null &&
      Number(item.discount_amount) > 0
    ) {
      return acc + Number(item.discount_amount) * Number(item?.quantity || 1);
    }

    if (
      item?.total_price_without_discount &&
      item?.total_price &&
      Number(item.total_price_without_discount) > Number(item.total_price)
    ) {
      return (
        acc +
        (Number(item.total_price_without_discount) - Number(item.total_price))
      );
    }

    if (item?.manual_discount && item.manual_discount.amount) {
      const qty = Number(item?.quantity || 1);
      const amt = Number(item.manual_discount.amount);
      if (item.manual_discount.type === "percentage") {
        const unitPrice = Number(item?.unit_price || 0);
        const base = amt < 100 ? unitPrice / (1 - amt / 100) : unitPrice;
        return acc + base * (amt / 100) * qty;
      }
      return acc + amt * qty;
    }

    const name = item?.cart_item_name || "";
    const percentMatch = name.match(/\((\d+(?:\.\d+)?)\s*%\s*OFF\)/i);
    const qty = Number(item?.quantity || 1);
    if (percentMatch) {
      const rate = Number(percentMatch[1]);
      if (rate > 0 && rate < 100) {
        const unitPrice = Number(item?.unit_price || 0);
        const base = unitPrice / (1 - rate / 100);
        return acc + base * (rate / 100) * qty;
      }
    }
    const flatMatch = name.match(
      /\((?:[^\d%)]*)\s*([\d,]+(?:\.\d+)?)\s*OFF\)/i,
    );
    if (flatMatch) {
      const flatVal = Number(flatMatch[1].replace(/,/g, ""));
      if (flatVal > 0) {
        return acc + flatVal * qty;
      }
    }

    return acc;
  }, 0);

  return total;
};

export const printStandardInvoice = (url) => {
  if (!url) return;

  if (
    typeof url === "string" &&
    (url.startsWith("data:image/") || url.match(/\.(jpeg|jpg|png|webp)($|\?)/i))
  ) {
    const iframe = document.createElement("iframe");
    document.body.appendChild(iframe);
    iframe.style.position = "absolute";
    iframe.style.width = "0px";
    iframe.style.height = "0px";
    iframe.style.border = "none";

    iframe.contentDocument.write(`
      <html>
        <head>
          <style>
            * { margin: 0; padding: 0; box-sizing: border-box; }
            body { width: 100%; margin: 0; }
            img {
              display: block;
              width: 100%;
              height: auto;
            }
            @media print {
              @page { margin: 10mm; size: auto; }
              body { margin: 0; width: 100%; }
            }
          </style>
        </head>
        <body>
          <img src="${url}" />
          <script>
            window.onload = function() {
              window.print();
              window.onafterprint = function() { window.close(); };
            };
          </script>
        </body>
      </html>
    `);
    iframe.contentDocument.close();

    setTimeout(() => {
      if (document.body.contains(iframe)) {
        document.body.removeChild(iframe);
      }
    }, 60000);
    return;
  }

  window.open(url, "_blank");
};
